var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.348 13.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#13249f;stroke:#13249f;stroke-miterlimit:10;stroke-width:.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.446,10.581H.457c-.197,0-.357-.16-.357-.357V3.385c0-.197.16-.357.357-.357h3.99c.197,0,.357.16.357.357v6.84c0,.197-.16.357-.357.357ZM.813,9.868h3.277V3.741H.813v6.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.236,13.509c-.066,0-.133-.018-.191-.055l-4.642-2.939c-.166-.105-.216-.326-.111-.492.105-.167.326-.216.492-.111l4.095,2.593V1.104l-4.095,2.593c-.166.105-.386.056-.492-.111-.105-.166-.056-.387.111-.492L9.046.155c.11-.07.249-.074.363-.011.114.063.185.182.185.312v12.696c0,.13-.071.25-.185.312-.054.03-.113.044-.172.044Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.519,9.374c-.091,0-.182-.035-.252-.104-.139-.139-.139-.365,0-.504.524-.524.812-1.22.812-1.961,0-.741-.288-1.437-.812-1.96-.139-.139-.139-.365,0-.504.139-.139.365-.139.504,0,.658.658,1.021,1.534,1.021,2.465,0,.931-.363,1.806-1.021,2.465-.07.07-.161.104-.252.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.257,11.112c-.091,0-.182-.035-.252-.104-.139-.139-.139-.365,0-.504,2.04-2.04,2.04-5.358,0-7.398-.139-.139-.139-.365,0-.504.139-.139.365-.139.504,0,2.318,2.318,2.318,6.089,0,8.406-.07.07-.161.104-.252.104Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a3a13ceabfc240534017a9a4fb8dfb6d.svg";
export { ForwardRef as ReactComponent };